export enum NavigationDirection {
	PREVIOUS = -1,
	NEXT = 1
}